import { classes, UnitFooterStyles } from './style'
import IconButton from '@mui/material/IconButton'
import Favorite from '@mui/icons-material/Favorite'
import LocalPhoneIcon from '@mui/icons-material/LocalPhone'
import Button from '@mui/material/Button'
import { Tooltip } from '@mui/material'

// eslint-disable-next-line react/prop-types
const UnitFooter = ({ unit }) => {
  return (
    <UnitFooterStyles className={classes.root}>
      <Tooltip title="Add to favorites" placement="top">
        <IconButton size="large" edge="start" color="inherit" aria-label="menu" sx={{ ml: 2 }}>
          <Favorite style={{ color: 'gray' }}/>
        </IconButton>
      </Tooltip>
      <div>
        <Tooltip title="Call now" placement="top">
          <IconButton size="large" edge="start" color="inherit" aria-label="menu" sx={{ ml: 2 }}>
            <LocalPhoneIcon style={{ color: 'gray' }}/>
          </IconButton>
        </Tooltip>
        {/* eslint-disable-next-line react/prop-types */}
        <Button variant="contained" disabled={!unit.available}>Contact</Button>
      </div>
    </UnitFooterStyles>
  )
}

export default UnitFooter
